/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * yesterday object
 * @export
 * @interface GetFwLeaderboardsYesterdayYesterday
 */
export interface GetFwLeaderboardsYesterdayYesterday {
    /**
     * Amount of kills
     * @type {number}
     * @memberof GetFwLeaderboardsYesterdayYesterday
     */
    amount?: number;
    /**
     * faction_id integer
     * @type {number}
     * @memberof GetFwLeaderboardsYesterdayYesterday
     */
    factionId?: number;
}

/**
 * Check if a given object implements the GetFwLeaderboardsYesterdayYesterday interface.
 */
export function instanceOfGetFwLeaderboardsYesterdayYesterday(value: object): value is GetFwLeaderboardsYesterdayYesterday {
    return true;
}

export function GetFwLeaderboardsYesterdayYesterdayFromJSON(json: any): GetFwLeaderboardsYesterdayYesterday {
    return GetFwLeaderboardsYesterdayYesterdayFromJSONTyped(json, false);
}

export function GetFwLeaderboardsYesterdayYesterdayFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetFwLeaderboardsYesterdayYesterday {
    if (json == null) {
        return json;
    }
    return {
        
        'amount': json['amount'] == null ? undefined : json['amount'],
        'factionId': json['faction_id'] == null ? undefined : json['faction_id'],
    };
}

export function GetFwLeaderboardsYesterdayYesterdayToJSON(json: any): GetFwLeaderboardsYesterdayYesterday {
    return GetFwLeaderboardsYesterdayYesterdayToJSONTyped(json, false);
}

export function GetFwLeaderboardsYesterdayYesterdayToJSONTyped(value?: GetFwLeaderboardsYesterdayYesterday | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'amount': value['amount'],
        'faction_id': value['factionId'],
    };
}

